var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMillustrationsSentry = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 56,
  height: 40,
  fill: "none",
  viewBox: "0 0 56 40"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillOpacity: 0.04,
  d: "M0 2a2 2 0 0 1 2-2h52a2 2 0 0 1 2 2v36a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 39,
  height: 23,
  x: 8.5,
  y: 8.5,
  fill: "#fff",
  stroke: "#CCCCD9",
  rx: 1.5
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#8A8A99",
  d: "M29.12 14.633a1.308 1.308 0 0 0-2.24 0l-1.842 3.155a9.02 9.02 0 0 1 4.97 7.465h-1.294a7.75 7.75 0 0 0-4.329-6.361L22.68 21.84a4.46 4.46 0 0 1 2.585 3.408h-2.971a.213.213 0 0 1-.174-.311l.823-1.4a3 3 0 0 0-.94-.532l-.815 1.4a1.27 1.27 0 0 0 .473 1.747c.193.109.41.167.633.168h4.068a5.43 5.43 0 0 0-2.24-4.847l.647-1.12a6.68 6.68 0 0 1 2.884 5.967H31.1a10.05 10.05 0 0 0-4.595-8.904l1.308-2.24a.215.215 0 0 1 .294-.076c.148.082 5.68 9.736 5.784 9.848a.213.213 0 0 1-.19.316h-1.333q.026.536 0 1.067h1.338a1.285 1.285 0 0 0 1.12-1.929z"
})));
export default SvgMillustrationsSentry;